// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"CW-z","sponsoredTooltipWrapper":"DW-z","sponsoredTooltip":"EW-z","newCard":"FW-z"};